import WithSidebar from 'Layout/WithSidebar';
import { productPageTitles } from 'components/NavigationSideBar/mockData';
import image from 'images/small-images-inside-text/wuxal.jpg';
import infoImage from 'images/info-image.jpg';
import infoImageMobile from 'images/info-image-mobile.jpg';
import youtubeImage from 'images/youtubeImage.jpg';
import aboutImage from 'images/about-product-image-text.jpg';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import ProductItemsBox from 'components/ProductItemsBox';
import { products, tabsData, vegetables } from 'components/ProductItems/mockData';
import GeneralInfoBox from 'components/GeneralInfoBox';
import { Button } from 'components/buttons/Button/Button';
import BenefitsBox from 'components/BenefitsBox';
import NavigationSideBar from 'components/NavigationSideBar';
import PDFBox from 'components/PDFBox';
import { data } from 'components/BenefitsBox/mockData';
import { aboutProductFiles } from 'components/PDFBox/mockData';
import ProductItemsBoxWithTabs from 'components/ProductItemsBox/ProductItemsBoxWithTabs';
import PictureComponent from 'components/PictureComponent';
import YoutubeLink from 'components/YoutubeLink';
import Banner from 'components/Banner';
import aboutProductBanner from 'images/aboutProductBanner.jpg';
import ProductCatalogBox from 'components/ProductCatalogBox';
import wuxalCatalog from 'images/wuxalCatalog.jpg';
import React from 'react';
import { calculateActiveIndex } from 'components/NavigationSideBar/helpers';
import NavigationSectionWrapper from 'components/NavigationSideBar/NavigationSectionWrapper';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';

const AboutProducts = () => {
    const [sectionsData, setSectionsData] = React.useState({});
    const [activeIndex, setActiveIndex] = React.useState(0);

    const pageContent = [
        <GeneralInfoBox>
            <h3>General information</h3>
            <p>
                These are multifunctional products for optimizing modern plant protection and nutrition technologies.
                Unlike microfertilizers, they are recommended as a component of tank mixtures in plant protection and
                nutrition systems. They have a high concentration of nutrients specially selected for the physiological
                needs of plants.
            </p>
            <p>
                The Wuxal offered in Ukraine is produced in Germany by order of UniferX International GmbH at the
                Aglukon Spezialdünger GmbH & Co KG plant.
            </p>
            <p>
                The plant, located in Düsseldorf, has been producing special fertilizers and biostimulants for foliar
                feeding and seed treatment under the highest German quality standards since 1928.
            </p>
            <img src={infoImage} alt="" />
            <p>
                Wuxal has been known on the Ukrainian market since 2003 and has gained a reputation as a high-quality,
                effective and reliable means of increasing crop productivity. The technologies implemented in Wuxal are
                one step ahead of modern cultivation technologies.
            </p>
            <Button type="read-more">READ MORE</Button>
        </GeneralInfoBox>,
        <>
            <PictureComponent srcBig={aboutImage} srcSmall={infoImageMobile} alt="info" className="pb-8" />
            <BenefitsBox title="Wuxal benefits" data={data}>
                <YoutubeLink
                    image={youtubeImage}
                    videoId="https://www.youtube.com/watch?v=KPhzCco_ku4"
                    title='What makes Wuxal’s different from "micronutrient fertilizers"?'
                />
            </BenefitsBox>
        </>,
        <ProductItemsBox title="Related products" data={products} />,
        <PDFBox title="Composition & compatibility" data={aboutProductFiles} />,
        <ProductItemsBox title="Wuxal crop nutrition programs" data={vegetables} />,
        <ProductItemsBoxWithTabs title="Wuxal trial results" data={tabsData} />,
        <ProductCatalogBox
            title="Wuxal catalog"
            image={wuxalCatalog}
            text={'Check out our Wuxal product catalog for detailed information on composition and usage.'}
        />,
    ];

    const arrLength = pageContent.length;
    const [refs, setRefs] = React.useState([]);

    React.useEffect(() => {
        setRefs(refs =>
            Array(arrLength)
                .fill()
                .map((_, i) => refs[i] || React.createRef()),
        );
    }, [arrLength]);

    React.useEffect(() => {
        setActiveIndex(calculateActiveIndex(sectionsData));
    }, [sectionsData]);

    return (
        <>
            <Banner
                title="Our products"
                image={aboutProductBanner}
                buttonText="FIND A DISTRIBUTOR"
                buttonType="find-desktop"
            />

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>about product</LabelButton>
                        <GradientText>
                            New <img src={image} alt="decor" /> Wuxal’s are <em>products of a higher level,</em> more
                            than just a product of fertilizer
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">
                                Wuxal® — is an <em>effective suspension</em> for foliar treatment of plants and seed
                                treatment, as well as a set of innovative solutions that allow you to achieve high
                                efficiency.
                            </GradientText>
                        </div>
                    </div>
                </div>
                <WithSidebar
                    Sidebar={<NavigationSideBar activeIndex={activeIndex} refs={refs} items={productPageTitles} />}
                >
                    {pageContent.map((item, index) => (
                        <div ref={refs[index]} key={index}>
                            <NavigationSectionWrapper index={index} setData={setSectionsData}>
                                {item}
                            </NavigationSectionWrapper>
                        </div>
                    ))}
                </WithSidebar>
            </section>
            <DefaultForm />
        </>
    );
};

export default AboutProducts;
